export default __webpack_public_path__ + "static/media/noPhoto.c1d06cbc.svg";